import { animated } from '@react-spring/web'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from '../../hooks/useIsMobile'
import { TextParser } from '../TextParser'
import './Timeline.css'

export const TIMELINE_ITEM_HEIGHT = window.innerHeight / 2

/**
 * Normalize any milestone color to the brand palette.
 * - Ancient/fire events → amber/gold (#FFD700)
 * - Tech/modern events → electric blue (#1E90FF)
 * - Unknown / off-brand fall back to the default border
 */
const normalizeColor = (rawColor) => {
  if (!rawColor) return '#3a3630'
  const FIRE_COLORS = ['#FF4500', '#FDBA16', '#FFD700', '#F36E21', '#FF8C00']
  const TECH_COLORS = ['#1E90FF', '#8A2BE2', '#4B0082', '#32CD32']
  if (FIRE_COLORS.some(c => rawColor.toUpperCase() === c.toUpperCase())) return '#FFD700'
  if (TECH_COLORS.some(c => rawColor.toUpperCase() === c.toUpperCase())) return '#1E90FF'
  return '#3a3630'
}

/** Count plain words in a string (strips HTML/markdown tags for a rough estimate) */
const wordCount = (str) => (str || '').replace(/<[^>]+>/g, '').split(/\s+/).filter(Boolean).length

export const Timeline = () => {
  const isMobile = useIsMobile()
  const { t } = useTranslation()
  const story = t('story', { returnObjects: true })

  return (
    <div className='page-container'>
      <div className='timeline-section-title'>
        <h2>{story.timelineTitle}</h2>
      </div>
      <animated.div className='page-content-container'>
        {story.milestones.map((milestone, index) => {
          const brandColor = normalizeColor(milestone.color)
          /* Long descriptions (>40 words) get centred; short ones alternate left/right */
          const isLong = wordCount(milestone.description) > 40
          let alignClass = ''
          if (!isMobile) {
            alignClass = isLong ? 'center' : (index % 2 === 0 ? 'right' : 'left')
          }
          return (
            <div
              key={index}
              className={`page-item ${alignClass}`}
            >
              <div
                className='page-content'
                style={{ borderColor: brandColor, boxShadow: `0 0 16px ${brandColor}22` }}
              >
                <div
                  className='timeline-era-badge'
                  style={{ background: `${brandColor}22`, color: brandColor }}
                >
                  <TextParser text={milestone.year} />
                </div>
                <p className='timeline-title'><TextParser text={milestone.title} /></p>
                <p className='timeline-description'><TextParser text={milestone.description} /></p>
              </div>
            </div>
          )
        })}
      </animated.div>
    </div>
  )
}

